import { render } from "./PartnerSkuRequestList.vue?vue&type=template&id=2a576126&scoped=true"
import script from "./PartnerSkuRequestList.vue?vue&type=script&lang=js"
export * from "./PartnerSkuRequestList.vue?vue&type=script&lang=js"

import "./PartnerSkuRequestList.vue?vue&type=style&index=0&id=2a576126&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a576126"]])

export default __exports__